import { DatePickerWithRange } from "components/ui/DatePickerWithRange";
import { parsedDateToDate } from "lib/dateUtils";
import ReadingFormatIcon from "components/shared/ReadingFormatIcon";
import useUserBookRead from "services/UserBookReadService/useUserBookReadService";
import EditionSelector from "components/EditionSelector/EditionSelector";
import { BookSerializersBookByline, UserBookSerializersUserBookDate } from "types/serializers";

export default function EditableDateRead({
  book,
  userBookRead: initialDateRead,
  useStore = true,
}: {
  book: BookSerializersBookByline;
  userBookRead: UserBookSerializersUserBookDate;
  useStore?: boolean;
}) {
  const settings = useStore ? {} : { userBookRead: initialDateRead };
  const { userBookRead, updateDates, deleteDate } = useUserBookRead({
    bookId: book.id,
    userBookReadId: initialDateRead.id,
    settings
  });
  if (!userBookRead) {
    return <></>;
  }

  return (
    <div className="flex items-center gap-2 font-semibold text-lg">
      <EditionSelector
        book={book}
        edition={userBookRead.edition}
        size="md"
        userBookRead={userBookRead}
      >
        <ReadingFormatIcon
          readingFormatId={userBookRead.edition?.readingFormatId}
        />
      </EditionSelector>

      <DatePickerWithRange
        showCalendarIcon={false}
        startDate={parsedDateToDate(userBookRead.startedAt)}
        endDate={parsedDateToDate(userBookRead.finishedAt)}
        onDelete={deleteDate}
        onChange={updateDates}
      />
    </div>
  );
}
